import { render } from "./Backups.vue?vue&type=template&id=2ec8a384"
import script from "./Backups.vue?vue&type=script&lang=js"
export * from "./Backups.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Dev\\Projects\\Web\\era-old.proj\\era.alpha-23-24.local\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__